import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import reportWebVitals from 'reportWebVitals';

import {
  NODE_ENV,
  SENTRY_DSN,
  SENTRY_SAMPLE_RATE,
  SENTRY_TRACES_SAMPLE_RATE,
  VERSION,
} from './Utils/constants';
import App from './App';

import 'react-toastify/dist/ReactToastify.css';
import 'Assets/styles/_core.scss';

if (NODE_ENV !== 'development') {
  Sentry.init({
    dsn: SENTRY_DSN,
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    sampleRate: SENTRY_SAMPLE_RATE,
    environment: NODE_ENV,
    integrations: [new BrowserTracing()],
    release: VERSION,
  });
}

export const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

reportWebVitals();
